import { HttpTypes } from "@medusajs/types"
import { Text } from "@medusajs/ui"

type LineItemOptionsProps = {
  variant: HttpTypes.StoreProductVariant | undefined
  "data-testid"?: string
  "data-value"?: HttpTypes.StoreProductVariant
}

const LineItemOptions = ({
  variant,
  "data-testid": dataTestid,
  "data-value": dataValue,
}: LineItemOptionsProps) => {
  const title = variant?.title?.trim() || ""

  const hiddenTitles = [
    "default variant",
    "default",
    "standalone default variant",
  ]

  const shouldShow =
    title.length > 0 && !hiddenTitles.includes(title.toLowerCase())

  return (
    <Text
      data-testid={dataTestid}
      data-value={dataValue}
      className="inline-block w-full overflow-hidden text-ellipsis whitespace-nowrap text-xs font-semibold text-black/80 min-h-[14px]"
    >
      {shouldShow ? title : "\u00A0"}
    </Text>
  )
}

export default LineItemOptions